import React, { Component } from 'react';
import { sendJson } from '../../backend/Backend';
import '../../css/style.css';
import '../Home.css';
import '../App.css';
import {Card,Alert} from 'react-bootstrap';
import { translate } from "react-i18next";
import AuthenticationService from '../../backend/AuthenticationService';


class PasswordChange extends Component {

  constructor(props) {
    super(props);

    //userService.logout();

    this.state = {
        newPassword:'',
        oldPassword:'',
        repwd:'',        
        submitted: false,
        loading: false,
        error: '',
        message:''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  pwdNotValidate(){
    return !this.state.newPassword || this.state.newPassword.length < 6 || this.state.newPassword != this.state.repwd
  }

    handleChange(e) {
        const { name, value } = e.target;
        let oldState = this.state;
        this.setState({
          ...oldState, 
          [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();
        let oldState = this.state;
        this.setState({...oldState, 
          submitted: true });
        const { newPassword, oldPassword, repwd } = this.state;

        // stop here if form is invalid
        if (!newPassword || !oldPassword || newPassword.length < 6 || newPassword !== repwd ) {
            return;
        }

        let email = AuthenticationService.getLoggedInUserName();
        if(!email){
            return;
        }
        
        oldState = this.state;
        this.setState({...oldState, 
          loading: true });
        this.onPasswordChange(email, oldPassword, newPassword);
    }

   
    onPasswordChange(email,oldPassword, password) {
      let user = { 'email':email, 'oldPassword':oldPassword, 'password':password};
        sendJson('post', 'users/pwdChange', user).then(
            received => {
              if(received.ok){
                  console.log("user saved  :-)");
                  let oldState = this.state;
                  this.setState({...oldState, 
                    loading: false,
                    message:'pwdChanged'
                  });
              }
            });
    }

    render() {
        const { t } = this.props;
        const { oldPassword, newPassword, repwd ,submitted, loading, error } = this.state;
        return (
            <div className="col-md-6 mt-5">
              <Card>
                <Card.Header className="text-primary">{t("pwdChange")}</Card.Header>
                <Card.Body>
                    <Card.Text>
                    { this.state.message ? 
                       <Alert key={'success'} variant={'success'}>
                       {t(this.state.message)}
                     </Alert>
                    :
                    <form name="form" onSubmit={this.handleSubmit}>
                    <div className={'form-group' }>
                        <input type="text" className="form-control" name="oldPassword" value={oldPassword} onChange={this.handleChange} 
                        placeholder={t("oldPassword")}  maxLength={250}/>
                    </div>
                    
                    <div className={'form-group' + (submitted && !newPassword ? ' has-error' : '')}>
                        <input type="password" className="form-control" name="newPassword" value={newPassword} onChange={this.handleChange} placeholder={t("newPassword")} 
                         maxLength={250} />
                        {submitted && (!newPassword || newPassword.length < 6) &&
                            <div className="text-danger">{t("pwdMin")}</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !repwd ? ' has-error' : '')}>
                        <input type="password" className="form-control" name="repwd" value={repwd} onChange={this.handleChange} placeholder={t("newRePassword")} />
                        {submitted && (!repwd || repwd !== newPassword) &&
                            <div className="text-danger">
                            {t("pwdNotCorrect")}
                            </div>
                        }
                    </div>
                    <div className="form-group">
                        <button className="btn btn-primary float-right" disabled={loading || this.pwdNotValidate()}>{t("send")}</button>
                        {loading &&
                            <img alt="loading..." src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                        }
                    </div>
                  
                

                </form>
                    }
                    </Card.Text>
                </Card.Body>
                </Card>
            </div>);
    }

}

export default translate("translations")(PasswordChange);
